import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const ScrollDownArrow = ({ width = '25', height = '15', ...rest }) => {
    return (_jsx(BaseIcon, { width: width, height: height, xmlns: 'http://www.w3.org/2000/svg', ...rest, children: _jsx("path", { d: 'M1.893 1.5L12.5 12.107 23.107 1.5', stroke: 'currentColor', strokeWidth: '3', fill: 'none' }) }));
};
//# sourceMappingURL=ScrollDownArrow.js.map